import { IApplicationState } from '../../types/redux';
import { ILinkedCardData } from '../../types/redux/paymentMethods';
import { selectPaymentMethodById } from './selectPaymentMethodById';

export const selectLinkedCardById =
  (id: string) =>
  (state: IApplicationState): ILinkedCardData => {
    const method = selectPaymentMethodById(id)(state);

    return method.linkedCard!;
  };
